import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"float":"left","margin":"12px"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (_ctx.Show)
    ? (_openBlock(), _createBlock(_component_Confirm, {
        key: 0,
        onClose: _ctx.Cancel
      }, {
        icon: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "icon",
              style: {width: '50px', height:'50px'},
              src: this.getIconPath(_ctx.icon)
            }, null, 8, _hoisted_2)
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.useModalDialogsV2 ? 'white-space: normal;' : 'padding-top:15px; white-space: normal;')
          }, _toDisplayString(_ctx.title), 5),
          (_ctx.innerHtml)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(_ctx.useModalDialogsV2 ? 'max-height: 300px; overflow: auto' : 'max-height: 300px; padding: 20px; overflow: auto')
              }, [
                _createElementVNode("div", { innerHTML: _ctx.innerHtml }, null, 8, _hoisted_3)
              ], 4))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          (_ctx.nullButtonText!=null)
            ? (_openBlock(), _createBlock(_component_CommonButton, {
                key: 0,
                type: _ctx.ButtonType.Default,
                text: _ctx.nullButtonText,
                onClick: _ctx.Null
              }, null, 8, ["type", "text", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.hideCancelButton!=true)
            ? (_openBlock(), _createBlock(_component_CommonButton, {
                key: 1,
                type: _ctx.ButtonType.Default,
                text: _ctx.cancelButtonText == null ? _ctx.Localizer.Localize('Cancel_PascalCase'): _ctx.cancelButtonText,
                onClick: _ctx.Cancel
              }, null, 8, ["type", "text", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CommonButton, {
            type: _ctx.ButtonType.Primary,
            text: _ctx.acceptButtonText == null ? _ctx.Localizer.Localize('Ok_PascalCase') : _ctx.acceptButtonText,
            onClick: _ctx.Accept
          }, null, 8, ["type", "text", "onClick"])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}